import React, { useEffect, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { MakeSelect } from "../MakeSelect";
import { ModelSelect } from "../ModelSelect";
import { CommonSelect } from "../CommonSelect";
import { YearSelect } from "../YearSelect";
import { AdminPageStyle } from "../../pages/admin/style";
import { useNewVehicle } from "../../common/hooks";
import { layoutStyle } from "../../pages/layout-ui/style";
import { modelApi } from "../../common/api";
import { mergeCalculatedComtracValues } from "../../common/constants/commonFunction";

export const ActionFormFundingNewVehicle = ({
  dropdownValue,
  closeModal,
  selectedRows,
  dealerId,
  companyId,
  setSelectedRows,
}) => {
  const { multipleNewVehicleApi, newVehicle } = useNewVehicle();
  const [yearValue, setYearValue] = useState();
  const [makeValue, setMakeValue] = useState();
  const [makeName, setMakeName] = useState();
  const [modelValueData, setModelValueData] = useState({
    modelId: null,
    model: "",
  });
  const [newAdd, setNewAdd] = useState("");
  const [mpgData, setMpgData] = useState(0);
  const [modelCsv, setModelCsv] = useState();
  const [fuelId, setFuelId] = useState();
  const [ageCount, setAgeCount] = useState();
  const [newResaleValue, setNewResaleValue] = useState(0);
  const [newCostValue, setNewCostValue] = useState(0);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [residualValue, setResidualValue] = useState(0);
  const [yearsValue, setYearsValue] = useState(0);
  const [fundValue, setFundValue] = useState();
  const [equityGain, setEquityGain] = useState(0);

  const classes = layoutStyle();
  const handleYearChange = (event, value) => {
    let data = event.target.value;
    let date = new Date().getFullYear();
    const filterdYear = dropdownValue?.yearArray?.filter(
      (yr) => yr?.id === data
    )?.[0];
    if (data) {
      setYearValue(data);
      if (filterdYear?.year) {
        let age = date - filterdYear.year;
        setAgeCount(age);
      }
    }
  };
  // do not remove the below commented code
  const handleFuelChange = (event) => {
    let data = event.target.value;
    setFuelId(data);
  };

  const handleFundChange = (event) => {
    let data = event.target.value;
    setFundValue(data);
  };

  const handleMpgChange = (e) => {
    if (e.target.value) {
      setMpgData(Number(e.target.value));
    } else {
      setMpgData(null);
    }
  };

  const handlePaymentAmount = (event) => {
    setPaymentAmount(event.target.value);
  };

  const handleCost = (event) => {
    setNewCostValue(event.target.value);
  };

  const handleEstimatedResaleValue = (event) => {
    setNewResaleValue(event.target.value);
  };

  const handleResidual = (event) => {
    setResidualValue(Number(event.target.value));
  };

  useEffect(() => {
    const resale = Number(newResaleValue) || 0;
    const cost = Number(newCostValue) || 0;
    const resPct = Number(residualValue) || 0;
    const residualAmt = cost * (resPct / 100);
    const equityGainValue = parseFloat((resale - residualAmt).toFixed(2));
    setEquityGain(equityGainValue);
  }, [newResaleValue, newCostValue, residualValue, fundValue]);

  const handleClickAuto = async () => {
    let modelId;
    const response = await modelApi.getModel({
      limit: 100,
      offset: 0,
      filter: {
        name: modelValueData?.model,
        makeId: makeValue,
        yearId: yearValue,
      },
      sorting: {
        fieldName: "",
        direction: "",
      },
    });
    if (response.data.data.length == 0) {
      const resData = await modelApi.createModel({
        name: modelValueData?.model,
        makeId: makeValue,
        yearId: yearValue,
        mpg: mpgData,
      });
      modelId = resData?.data?.data;
    } else {
      modelId = response?.data?.data[0]?.id;
    }
    const latestSelectedRows = selectedRows.map((selectedRow) => {
      const selectedId = selectedRow.id || selectedRow.newVehicleId;
      return (
        newVehicle?.find(
          (vehicle) => (vehicle.id || vehicle.newVehicleId) === selectedId
        ) || selectedRow
      );
    });
    let ids = latestSelectedRows.map((items) => items.id || items.newVehicleId);
    let editPayload = {
      updateIds: latestSelectedRows.map((item) => ({
        id: item.id || item.newVehicleId,
        yearId: yearValue,
        makeId: makeValue,
        modelId: modelId,
        newFuelId: fuelId,
        fundingTypeId: fundValue || item.fundingTypeId,
        mpg: mpgData > 0 ? mpgData : item.newMpg || item.mpg,
        paymentAmount:
          paymentAmount != null && paymentAmount !== "" ? Number(paymentAmount) : item.paymentAmount,
        newVehicleCost:
          newCostValue != null && newCostValue !== "" ? Number(newCostValue) : item.newVehicleCost,
        newEstimatedResaleValue:
          newResaleValue != null && newResaleValue !== "" ? Number(newResaleValue) : item.newEstimatedResaleValue,
        residualPercentage:
          residualValue != null && residualValue !== "" ? Number(residualValue) : item.residualPercentage,
        equityGain:
          equityGain != null && equityGain !== undefined
            ? equityGain
            : item.equityGain,
        ...(Number(yearsValue) > 0 && {
          years: Number(yearsValue),
          proposedCycle: Number(yearsValue),
          termMonths: Number(yearsValue) * 12,
        }),
      })),
    };
    const finalPayload = {
      ...editPayload,
      companyId: companyId,
      dealerId: dealerId,
    };
    let payload = {
      year: yearValue,
      make: makeValue,
      modelId: modelId,
      model: modelValueData?.model,
      newAdd: newAdd,
    };
    await multipleNewVehicleApi({ values: finalPayload, newAdd: payload });

    if (typeof setSelectedRows === "function") {
      const updatedRows = mergeCalculatedComtracValues(selectedRows, {
        paymentAmount: Number(paymentAmount || 0),
        netCapitalizedCost: Number(newCostValue || 0),
        residualPercentage: Number(residualValue || 0),
      });
      setSelectedRows(updatedRows);
    }

    closeModal();
  };
  useEffect(() => {
    const selectedVehicle = selectedRows?.[0];
    if (!selectedVehicle) return;

    setYearValue(selectedVehicle?.newYearId || selectedVehicle?.yearId);
    setMakeValue(selectedVehicle?.newMakeId || selectedVehicle?.makeId);
    setModelValueData({
      modelId: selectedVehicle?.newModelId || selectedVehicle?.modelId || null,
      model: selectedVehicle?.newModel || selectedVehicle?.model || "",
    });
    setMpgData(selectedVehicle?.newMpg || selectedVehicle?.mpg || 0);
    setFuelId(selectedVehicle?.newFuelId || selectedVehicle?.fuelId || null);
    setFundValue(
      selectedVehicle?.fundingTypeId
        ? selectedVehicle?.fundingTypeId
        : selectedVehicle?.fundingType || null
    );
    setPaymentAmount(selectedVehicle?.paymentAmount || 0);
    setNewCostValue(selectedVehicle?.newVehicleCost || 0);
    setNewResaleValue(selectedVehicle?.newEstimatedResaleValue || 0);
    setResidualValue(selectedVehicle?.residualPercentage || 0);
    setYearsValue(selectedVehicle?.years || selectedVehicle?.proposedCycle || (selectedVehicle?.termMonths ? Math.round(selectedVehicle.termMonths / 12) : 0));
    setEquityGain(selectedVehicle?.equityGain || 0);
  }, [selectedRows]);

  useEffect(() => {
    if (modelValueData === null) {
      setMpgData(0);
    }
  }, [modelValueData]);

  return (
    <>
      <Box className={classes.divMt10}>
        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>New Vehicle Year</Box>
          <YearSelect
            yearValue={yearValue}
            handleYearChange={handleYearChange}
            setYear={""}
            width={100}
          />
        </Box>

        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>New Vehicle Make</Box>
          <MakeSelect
            setMakeValue={setMakeValue}
            setMakeName={setMakeName}
            setModelValueData={setModelValueData}
            width={100}
            setMpgData={setMpgData}
          />
        </Box>
        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>New Vehicle Model</Box>
          <ModelSelect
            makeValue={makeValue}
            modelValueData={modelValueData}
            setModelValueData={setModelValueData}
            setMpgData={setMpgData}
            yearValue={yearValue}
            setModelCsv={setModelCsv}
            width={100}
            newAdd={newAdd}
            setNewAdd={setNewAdd}
          />
        </Box>
        {/* do not remove the below commented code */}
        {/* <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>New Vehicle Fuel </Box>
          <CommonSelect
            className={classes.textinput}
            handleChange={handleFuelChange}
            menuProp={""}
            option={dropdownValue?.fuelListArray}
            value={fuelId}
            width={100}
          />
        </Box> */}
        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>Funding Type</Box>
          <CommonSelect
            className={classes.textinput}
            handleChange={handleFundChange}
            menuProp={""}
            option={dropdownValue?.fundListArray}
            value={fundValue}
            width={100}
          />
        </Box>
        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>New Vehicle MPG</Box>
          <TextField
            id="standard-basic"
            variant="standard"
            type="number"
            className={classes.textinput}
            value={mpgData}
            onChange={handleMpgChange}
            sx={{ width: 100 }}
          />
        </Box>
        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>Payment Amount</Box>
          <TextField
            id="standard-basic"
            variant="standard"
            type="number"
            className={classes.textinput}
            value={paymentAmount}
            onChange={handlePaymentAmount}
            sx={{ width: 100 }}
          />
        </Box>
        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>New Vehicle Cost</Box>
          <TextField
            id="standard-basic"
            variant="standard"
            type="number"
            className={classes.textinput}
            value={newCostValue}
            onChange={handleCost}
            sx={{ width: 100 }}
          />
        </Box>
        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>
            New Estimated Resale Value
          </Box>
          <TextField
            id="standard-basic"
            variant="standard"
            type="number"
            className={classes.textinput}
            value={newResaleValue}
            onChange={handleEstimatedResaleValue}
            sx={{ width: 100 }}
          />
        </Box>
        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>Residual %</Box>
          <TextField
            id="standard-basic"
            variant="standard"
            type="number"
            className={classes.textinput}
            value={residualValue}
            onChange={handleResidual}
            sx={{ width: 100 }}
          />
        </Box>
        <Box className={classes.actionDialogCommon}>
          <Box className={classes.dailogTitleInput}>Years (Term in Months ÷ 12)</Box>
          <TextField
            id="standard-basic"
            variant="standard"
            type="number"
            className={classes.textinput}
            value={yearsValue}
            onChange={(e) => setYearsValue(e.target.value)}
            sx={{ width: 100 }}
          />
        </Box>
        <Box className={classes.actionButtonDialog}>
          <Button
            onClick={() => closeModal()}
            className={classes.addActionButton}
          >
            Back
          </Button>
          <Button className={classes.addActionButton} onClick={handleClickAuto}>
            Save
          </Button>
        </Box>
      </Box>
    </>
  );
};
